import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { Export, ExportType } from 'depoto-core/src/entities'
import { CoreService } from '../../services'
import { ModalContainerComponent } from '../../components/_common/modal-container/modal-container.component'
import { exportsColumns } from '../../utils/definitions.util'
import * as Sentry from '@sentry/angular-ivy'

const DEFAULT_FILTERS = {
  sortProp: 'created',
  sortDir: 'desc',
}

@Component({
  selector: 'app-exports',
  templateUrl: 'exports.component.html',
})
export class ExportsComponent extends BaseListing implements OnInit, OnDestroy {
  @ViewChild('modal') childModal: ModalContainerComponent
  @Input() entity: string
  headerTitle: string
  listingColumns: ListingItem[] = exportsColumns
  exports: any[] = []
  types: ExportType[] = []
  selectedType: string
  totalItems = 0
  currentPage: number
  endPage: number
  filters = DEFAULT_FILTERS
  refreshInterval: any = null
  loading = true
  date: string
  isShown = false
  constructor(protected core: CoreService) {
    super(core)
    this.getStorageKey('exports')
  }

  ngOnInit() {
    this.filters = DEFAULT_FILTERS
  }

  ngOnDestroy() {
    this.stopRefreshing()
  }

  async getTypes() {
    try {
      const exportTypes = await this.core.services.export
        .getTypes(
          {},
          {
            id: null,
            name: null,
            format: null,
            group: null,
          },
        )
        .then(res => res.items || [])
      this.types = [...exportTypes]
        .filter(t => t.group === this.entity)
        .map(value => {
          return { ...value, name: 'export.type.' + value.id }
        })
    } catch (e) {
      console.log(e)
    }
  }

  async filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false) {
    if (this.isShown) {
      this.loading = true
      this.currentPage = pageNo
      const filters: any = {
        group: this.entity,
      }
      if (this.selectedType?.length) {
        filters.types = [this.selectedType]
      }
      let result = await this.core.services.export.getList(
        { page: pageNo, sort: sortProp, direction: sortDir, filters },
        {
          id: null,
          generated: null,
          created: null,
          url: null,
          type: {
            id: null,
            name: null,
            format: null,
            group: null,
          },
          filter: null,
          createdBy: { id: null, name: null },
          note: null,
        },
      )
      this.loading = false
      this.reloading = false
      result = {
        ...result,
        items: result?.items?.map(value => {
          return { ...value, type: { ...value.type, name: 'export.type.' + value.type.id } }
        }),
      }
      if (!concat) {
        this.exports = result?.items?.map(ex => new Export(ex))
      } else {
        result?.items?.forEach(ex => {
          this.exports.push(new Export(ex))
        })
      }
      this.totalItems = result.paginator ? result.paginator.totalCount : 0
      this.endPage = result.paginator ? result.paginator.endPage : 0
    }
  }

  download(exportObj: Export) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(exportObj.url)
  }

  async showChildModal(): Promise<void> {
    this.isShown = true
    this.headerTitle = `exports.${this.entity}`
    this.childModal.showChildModal()
    await this.getTypes()
    if (this.types?.length === 1) this.selectedType = this.types[0].id
    this.startRefreshing('filter')
    await this.filter()
  }

  hideChildModal(): void {
    this.isShown = false
    this.stopRefreshing()
    this.childModal.hideChildModal()
  }
}
